import { add, setHours, setMinutes } from 'date-fns';
import { DateHelperProps } from '../../utils/returnDateCalculator/types';

const funcs = {
    fixDateAndTime: ({
        returnDatePriceCalculator,
        setReturnDatePriceCalculator,
        mySetFieldValue,
        toastify,
        numDays,
        message,
        // numRentalDays = 0,
        numRentalDays,
        collectReturnSaturday,
        isEarlyClose,
        // displayMessage = true,
        // isVan = false,
    }: DateHelperProps) => {
        const returnHours = returnDatePriceCalculator.getHours();
        const returnMinutes = returnDatePriceCalculator.getMinutes();
        const returnDay = returnDatePriceCalculator.getDay();

        const isSunday = returnDay === 0;
        const isSaturday = returnDay === 6;

        // const is530pmSaturday =
        //     isSaturday && returnHours === 17 && returnMinutes === 30;

        const isSundayAfter6pm =
            isSunday && returnHours >= 18 && returnMinutes > 0;

        const newReturnDate = isSundayAfter6pm
            ? returnDatePriceCalculator
            : add(returnDatePriceCalculator, {
                  days: isEarlyClose
                      ? numDays // For early close, use numDays directly
                      : numRentalDays === 1 &&
                          isSaturday &&
                          !collectReturnSaturday
                        ? numDays - 1
                        : numDays,
              });

        let newReturnDateTime = null;
        if (isSundayAfter6pm) {
            newReturnDateTime = returnDatePriceCalculator;
        } else {
            newReturnDateTime = setHours(
                setMinutes(new Date(newReturnDate), 30),
                17
            );
            if (
                isSunday &&
                numRentalDays === 1 &&
                returnDatePriceCalculator.getHours() === 17 &&
                returnDatePriceCalculator.getMinutes() === 30
            ) {
                newReturnDateTime = add(returnDatePriceCalculator, {
                    days: -1,
                });
            }
        }

        const derivedDateAndTime =
            numRentalDays && numRentalDays > 2 && !isSunday
                ? returnDatePriceCalculator
                : newReturnDateTime;
        // Debug to here
        setReturnDatePriceCalculator(derivedDateAndTime);
        mySetFieldValue('returnDatePriceCalculator', derivedDateAndTime);
        toastify.info(message, {
            toastId: 'returningSunday',
        });
    },
};

export default funcs;
